export default __webpack_public_path__ + "static/media/laurenjames-desk.9068d7f3.mp4";